export const UserEmailTooltip = () => <>Person's email from Bayer AzureAD.</>;
